import React from 'react';
import { motion } from 'framer-motion';
import PrimaryButton from '../components/ui/PrimaryButton';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import { Link } from 'react-router-dom';

const { FiLock, FiCheckCircle } = FiIcons;

const LOGO_URL = "https://s.phonesites.com/v0/b/phonesites-prod.appspot.com/o/images%2F6rHBijo2pUQV1ZlpCwFjbdqdjG53%2F1739904727601*CleanShot_2025-01-14_at_17*20*37_2x-removebg-preview*png?alt=media&token=74c8e271-9e91-4a59-9889-a2589d88b1fa";

const CheckoutPage = () => {
  const goToExternal = () => {
    window.location.href = "https://app.paythen.co/company/elite/plan/didi43uyi5";
  };

  return (
    <div className="min-h-screen bg-slate-50 flex flex-col">
      <header className="bg-white border-b border-slate-200 py-6 px-6 flex justify-center items-center">
        <img src={LOGO_URL} alt="VehicleAccel" className="h-10 w-auto" />
      </header>
      
      <main className="flex-grow flex items-center justify-center p-4">
        <motion.div 
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          className="max-w-md w-full bg-white p-8 rounded-2xl shadow-xl border border-slate-200 text-center"
        >
          <div className="w-16 h-16 bg-yellow-100 text-yellow-600 rounded-full flex items-center justify-center mx-auto mb-6">
            <SafeIcon icon={FiCheckCircle} className="text-3xl" />
          </div>
          
          <h2 className="text-2xl font-black uppercase mb-4">Almost There!</h2>
          <p className="text-slate-600 mb-8">
            Click below to complete your secure checkout and start scaling your vehicle sales.
          </p>
          
          <PrimaryButton fullWidth onClick={goToExternal}>
            Go To Secure Checkout
          </PrimaryButton>
          
          <div className="mt-6 flex items-center justify-center gap-2 text-sm text-slate-400">
            <SafeIcon icon={FiLock} className="text-green-500" />
            Secure Redirect
          </div>

          <div className="mt-8">
            <Link to="/" className="text-sm text-slate-400 hover:text-slate-600 underline">
              &larr; Back to offer
            </Link>
          </div>
        </motion.div>
      </main>
    </div>
  );
};

export default CheckoutPage;